import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-place-detail-dialog',
  templateUrl: './place-detail-dialog.component.html',
  styleUrls: ['./place-detail-dialog.component.scss']
})
export class PlaceDetailDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
